import {
    JoinLiveQuizSessionResponse,
    LiveQuizQuestionSnapshot,
    LiveQuizSessionSummary,
    LiveQuizSettingsInput,
} from '../../types/index.ts';

import ajax from './ajax';

export interface LiveQuizJoinCodeLookup {
    sessionId: string;
    joinCode: string;
    examTitle: string;
    status: string;
    totalQuestions: number;
    participantCount: number;
}

export type LiveQuizHostSession = LiveQuizSessionSummary & { questions: LiveQuizQuestionSnapshot[] };

class LiveQuizService {
    async createSession(examId: string, settings?: LiveQuizSettingsInput): Promise<LiveQuizSessionSummary> {
        return ajax.post('/api/live-quiz/sessions', { examId, settings });
    }

    async joinSession(joinCode: string, name: string): Promise<JoinLiveQuizSessionResponse> {
        return ajax.post('/api/live-quiz/sessions/join', { joinCode, name });
    }

    async lookupJoinCode(joinCode: string): Promise<LiveQuizJoinCodeLookup> {
        return ajax.get(`/api/live-quiz/sessions/by-code/${encodeURIComponent(joinCode)}`);
    }

    async getSession(sessionId: string): Promise<LiveQuizSessionSummary> {
        return ajax.get(`/api/live-quiz/sessions/${sessionId}`);
    }

    async getHostSession(sessionId: string): Promise<LiveQuizHostSession> {
        return ajax.get(`/api/live-quiz/sessions/${sessionId}/host`);
    }
}

export default new LiveQuizService();
